import { render, staticRenderFns } from "./ToolsTwisting.vue?vue&type=template&id=be10aac8&scoped=true"
import script from "./ToolsTwisting.vue?vue&type=script&lang=js"
export * from "./ToolsTwisting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be10aac8",
  null
  
)

export default component.exports